import { setAnalyticsAccount } from "./appAnalytics";

import type { Session } from "@supabase/supabase-js";

// Sessão em memória, alimentada pelo AuthProvider. Consumidores fire-and-forget
// (como o reporter de erro) usam este snapshot em vez de abrir outro
// supabase.auth.getSession() e disputar o lock do GoTrue durante o boot.
let currentSession: Session | null = null;

export function setCurrentAuthSession(session: Session | null): void {
  currentSession = session;
  void setAnalyticsAccount(session?.user.id ?? null);
}

export function getCurrentAccessToken(): string | null {
  return currentSession?.access_token ?? null;
}

export function getCurrentAuthSession(): Session | null {
  return currentSession;
}
